import i18next from 'i18next';
/**
 * DataDisposalMethod Integration
 * Generated by AI
 */
import { toast } from 'sonner';
import { getIntegrationErrorMessage } from '@/lib/integration-error-message.js';
// TODO: Check store import
// import { useDataDisposalMethodStore } from '@/store/data-disposal-method.store.js';
import { Logger } from '@/lib/app-log.js';

export class DataDisposalMethodIntegration {
    constructor(sdkService) {
        this.service = sdkService;
    }

    async fetchAll(params = {}) {
        /*
        const store = useDataDisposalMethodStore.getState();
        store.setLoading(true);
        */
        try {
            const response = await this.service.getAll(params);
            
            /*
            store.setItems(response.data);
            if (response.pagination) store.setPagination(response.pagination);
            */
            
            return { success: true, data: response.data };
        } catch (error) {
            toast.error(getIntegrationErrorMessage(error));
            /* store.setError(error.message); */
            return { success: false, error: getIntegrationErrorMessage(error) };
        } finally {
            /* store.setLoading(false); */
        }
    }

    async getById(id) {
        try {
            const response = await this.service.getById(id);
            return { success: true, data: response.data };
        } catch (error) {
            toast.error(getIntegrationErrorMessage(error));
            return { success: false, error: getIntegrationErrorMessage(error) };
        }
    }

    async create(data) {
        try {
            const response = await this.service.create(data);
            toast.success(i18next.t('kvkkSimpleDefinitions:dataDisposalMethod.messages.createSuccess', { defaultValue: 'Disposal method created' }));
            return { success: true, data: response.data };
        } catch (error) {
            toast.error(getIntegrationErrorMessage(error));
            return { success: false, error: getIntegrationErrorMessage(error) };
        }
    }

    async update(id, data) {
        try {
            const response = await this.service.update(id, data);
            toast.success(i18next.t('kvkkSimpleDefinitions:dataDisposalMethod.messages.updateSuccess', { defaultValue: 'Disposal method updated' }));
            return { success: true, data: response.data };
        } catch (error) {
            toast.error(getIntegrationErrorMessage(error));
            return { success: false, error: getIntegrationErrorMessage(error) };
        }
    }

    async delete(id) {
        try {
            await this.service.delete(id);
            toast.success(i18next.t('kvkkSimpleDefinitions:dataDisposalMethod.messages.deleteSuccess', { defaultValue: 'Disposal method deleted' }));
            return { success: true };
        } catch (error) {
            toast.error(getIntegrationErrorMessage(error));
            return { success: false, error: getIntegrationErrorMessage(error) };
        }
    }
}
